// src/services/workOrderInventoryService.js
import { authenticatedFetch, handleApiError } from './api';

const API_URL = '/work-order-inventory';

const getItemsForWorkOrder = (workOrderId) => {
  return authenticatedFetch(`${API_URL}/${workOrderId}`).catch(handleApiError);
};

const addItemsToWorkOrder = (workOrderId, items) => {
  return authenticatedFetch(API_URL, {
    method: 'POST',
    body: JSON.stringify({ workOrderId, items }),
  }).catch(handleApiError);
};

// --- UPDATE: New functions for AI Part Suggestions ---

/**
 * Fetches all AI-generated part suggestions for a work order.
 * @param {string} workOrderId - The ID of the work order.
 * @returns {Promise<Array>} A list of suggestion objects.
 */
const getSuggestions = (workOrderId) => {
  return authenticatedFetch(`${API_URL}/${workOrderId}/suggestions`).catch(handleApiError);
};

/**
 * Accepts a suggestion, adding the part to the work order's used inventory.
 * @param {number} suggestionId - The ID of the suggestion.
 * @param {object} payload - The data needed to add the item { work_order_id, item_id, quantity_used }.
 * @returns {Promise<object>} The success message from the backend.
 */
const acceptSuggestion = (suggestionId, payload) => {
  return authenticatedFetch(`${API_URL}/suggestions/${suggestionId}/accept`, {
    method: 'POST',
    body: JSON.stringify(payload),
  }).catch(handleApiError);
};

/**
 * Rejects an AI-generated part suggestion.
 * @param {number} suggestionId - The ID of the suggestion.
 * @returns {Promise<object>} The success message from the backend.
 */
const rejectSuggestion = (suggestionId) => {
  return authenticatedFetch(`${API_URL}/suggestions/${suggestionId}/reject`, {
    method: 'PATCH',
  }).catch(handleApiError);
};

// --- END UPDATE ---

const workOrderInventoryService = {
  getItemsForWorkOrder,
  addItemsToWorkOrder,
  // --- UPDATE: Add new functions to the exported service object ---
  getSuggestions,
  acceptSuggestion,
  rejectSuggestion,
  /**
   * Submits user feedback for a part suggestion.
   * @param {number} suggestionId - The ID of the suggestion.
   * @param {number} score - The feedback score (1 or -1).
   * @returns {Promise<object>}
   */
  submitSuggestionFeedback: async (suggestionId, score) => {
    const endpoint = `${API_URL}/suggestions/${suggestionId}/feedback`;
    return authenticatedFetch(endpoint, {
      method: 'POST',
      body: JSON.stringify({ score }),
    }).catch(handleApiError);
  },
  // --- END UPDATE ---
};

export default workOrderInventoryService;
